<template>
  <!-- 外层容器div不要去除，否则此处会报一堆警告 -->
  <div>
    <div class="shoppingCarPage">
      <!-- 页面顶部 -->
      <section class="topWrap">
        购物车<span v-if="goodNum > 0"> ({{ goodNum }})</span>
        <div class="manageBtn themeColor" @click="clickManageBtn">
          {{ isManage ? '完成' : '管理' }}
        </div>
      </section>

      <!-- 内容区域 -->
      <section class="contentWrap">
        <div v-show="isShowPaln">
          <carTypeCard ref="palnTypeCardRef" :data="planData" :isManage="isManage"></carTypeCard>
        </div>
        <div v-show="isShowTyre">
          <carTypeCard ref="tyreTypeCardRef" :data="tyreData" :isManage="isManage"></carTypeCard>
        </div>
        <div v-show="isShowShop">
          <carTypeCard ref="shopTypeCardRef" :data="shopData" :isManage="isManage"></carTypeCard>
        </div>
         <div v-show="isShowTyrePlan">
          <carTypeCard ref="tyrePlanCardRef" :data="tyrePlanData" :isManage="isManage"></carTypeCard>
        </div>
      </section>

      <!-- 删除确认弹窗 -->
      <van-dialog
        v-model:show="isShowDialog"
        title=""
        :before-close="handleDelete"
        show-cancel-button
        confirm-button-text="删除"
        confirm-button-color="#3088c5"
      >
        <div class="dialogContent">是否删除商品？</div>
      </van-dialog>
      <!-- 编辑物品弹窗 -->
      <teleport to="#app">
        <ConfirmGoods :datas="confirmGoodData" :showPopUp="showNum" currentType="shoppingCar" @updateShoppingSuccess="refreshShoppingCar" />
      </teleport>

      <!-- 轮胎确认弹窗 -->
      <teleport to="#app">
        <ConfirmTyre :datas="confirmGoodData" :showTyreNum="showTyreNum" @updateShoppingSuccess="refreshShoppingCar" from="shoppingCar" />
      </teleport>

      <van-dialog v-model:show="isShowErrDialog" confirm-button-text="知道了" confirm-button-color="#3088c5" :closed="closedErrDialog">
        <div class="dialogContent">
          <h3>提示</h3>
          <div><p v-html="errDialogMsg"></p></div>
        </div>
      </van-dialog>

      <Loading v-if="isShowLoad" />
      <van-divider v-if="isShowNoData" dashed :style="dividerStyle"> 无购物车数据</van-divider>
    </div>
    <!-- 底部按钮 -->
    <section class="bottomWrap">
      <bottom
        :currentType="currentType"
        :isManage="isManage"
        :totalPrice="totalPrice"
        :isShowDiscount="isShowDiscount"
        :totalProductAmount="totalProductAmount"
        :couponListParam="couponListParam"
        :tyreSelectedList="tyreSelectedList"
        @checkAllGoods="checkAllGoods"
        @delete="deleteSelectFn"
        @toBalance="toBalance"
      ></bottom>
    </section>
  </div>
</template>

<script>
export { default } from '@/util/shoppingCar/setup.js'
</script>

<style lang="scss" scoped>
.shoppingCarPage {
  background-color: #f5f5f5;
  color: #666666;
  font-size: 12px;
  overflow: auto;
  :deep(.van-checkbox__icon) {
    font-size: 14px;
  }
  :deep(.van-checkbox__label--disabled) {
    color: #323233;
  }
  :deep(.van-popup.van-dialog button) {
    background: #fff;
    color: #666;
  }
  :deep(.dialogContent) {
    padding: 30px 10px 20px;
    color: #666;
    font-size: 13px;
    font-weight: 400;
    h3 {
      margin-bottom: 12px;
      color: #333;
      font-size: 16px;
    }
    p {
      margin-bottom: 5px;
    }
  }
}
.topWrap {
  position: relative;
  height: 48px;
  margin-bottom: 8px;
  background-color: #fff;
  line-height: 48px;
  font-weight: 600;
  font-size: 16px;
}
.manageBtn {
  position: absolute;
  padding-right: 20px;
  width: 48px;
  height: 48px;
  top: 0;
  right: 0px;
  font-size: 14px;
  text-align: right;
}
.contentWrap {
  margin-bottom: 100px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.bottomWrap {
  position: fixed;
  bottom: 50px;
  width: 100%;
  height: 48px;
  background-color: #fff;
  // background-color: rgb(190, 42, 42);
  line-height: 48px;
  font-weight: 600;
  font-size: 14px;
  color: #666;
  vertical-align: middle;
  :deep(.van-checkbox) {
    padding-left: 20px;
    vertical-align: middle;
  }
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
